import React from 'react';
import NavContext from "../NavContext";

export default (App) => {
  const Component = (props) => {
    return (
      <NavContext.Consumer>
        {(appProps) => {
          props = {
            ...appProps,
            ...props,
          };
          return <App {...props} />;
        }}
      </NavContext.Consumer>
    );
  };
  Component.Layout = App.Layout;
  Component.displayName = App.displayName;
  return Component;
};
